import * as yup from 'yup';

export const trialSchema = yup.object().shape({
  displayName: yup.string().required('Please enter your name.'),
  email: yup
    .string()
    .email('It must be an email address')
    .required('Please enter your email address.'),
});
